import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, CountryFlag, FlexBox, IconButton, Switch, Table, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { getCountryCodeFromPhoneNumber } from 'lib-shared-phone-numbers';
import { useCallback, useMemo } from 'react';
import { ratingApi } from 'apis/rating';
import { appActions } from 'app/app.actions';
import { getCountryNameFromCountryCode } from 'utils/countries';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import styles from './phoneSurveysTableRow.module.scss';
/** Represents a row of the link between a phone number and a survey. */
export const PhoneSurveyTableRow = ({ phoneSurveyLink, onItemChanged, }) => {
    const [unlinkRatingSettings] = ratingApi.useLazyUnlinkRatingSettingsQuery();
    const { countryCode, countryName } = useMemo(() => {
        const countryCode = getCountryCodeFromPhoneNumber(phoneSurveyLink.phoneNumber.e164_format);
        return {
            countryCode,
            countryName: countryCode && getCountryNameFromCountryCode(countryCode),
        };
    }, [phoneSurveyLink.phoneNumber]);
    const dispatch = useAppDispatch();
    const openSelectSurveyModal = () => {
        dispatch(appActions.showModal({
            modal: {
                type: 'settings:selectSurvey',
                arg: {
                    contactPoint: e164_format,
                    contactPointKind: 'phone_number',
                    onSurveyLinked: (newLink) => onItemChanged({
                        phoneNumber: phoneSurveyLink.phoneNumber,
                        link: newLink,
                    }),
                    currentSurvey: currentSurveyLink,
                },
            },
        }));
    };
    const { phoneNumber: { e164_format, name }, link, } = phoneSurveyLink;
    const handleUnlink = useCallback(() => {
        link &&
            unlinkRatingSettings({
                rating_settings_id: link.rating_settings_id,
                contact_point: link === null || link === void 0 ? void 0 : link.contact_point,
                contact_point_kind: link === null || link === void 0 ? void 0 : link.contact_point_kind,
            }).then(() => 
            // removes the survey link from the row
            onItemChanged({
                phoneNumber: phoneSurveyLink.phoneNumber,
                link: undefined,
            }));
    }, [link, onItemChanged, phoneSurveyLink.phoneNumber, unlinkRatingSettings]);
    const currentSurveyLink = useMemo(() => {
        return link && (link === null || link === void 0 ? void 0 : link.name)
            ? {
                id: link.rating_settings_id,
                name: link === null || link === void 0 ? void 0 : link.name,
            }
            : undefined;
    }, [link]);
    return (_jsx(_Fragment, { children: _jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: _jsxs(FlexBox, Object.assign({ gap: '300' }, { children: [countryCode && (_jsx(Box, Object.assign({ className: styles.countryFlagContainer }, { children: _jsx(CountryFlag, { countryCode: countryCode, size: 20 }) }))), _jsxs(FlexBox, Object.assign({ flexDirection: "column" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "2" }, { children: e164_format })), countryName && (_jsx(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, { children: countryName })))] }))] })) }), _jsx(Table.Td, { children: name }), _jsx(Table.Td, { children: link ? (_jsx(Text.Paragraph, { children: link.name })) : (_jsx(Button, Object.assign({ icon: "plus", variant: "secondary", disabled: false, onClick: openSelectSurveyModal }, { children: "Connect a survey" }))) }), _jsx(Table.Td, Object.assign({ align: "center" }, { children: _jsx(Switch, { className: styles.switch, name: name !== null && name !== void 0 ? name : '', value: name !== null && name !== void 0 ? name : '', checked: link ? true : false, disabled: !link, onChange: handleUnlink }) })), _jsx(Table.Td, { children: link && (_jsx(Tooltip, Object.assign({ content: "Edit", dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: "pen", onClick: openSelectSurveyModal }) }))) })] }) }));
};
